import type { JSX, ReactNode } from "react"
import type { BannerFixoProps } from "../../banner-fixo.props"

interface ContentBannerProps {
    banner: BannerFixoProps
    children: ReactNode
}

export function ContentBanner({ banner, children }: ContentBannerProps): JSX.Element {
    return (
        banner.url ? (
            <a
                href={banner.url}
                target={banner.link_target_banner}
                {...(banner.legenda) && { title: banner.legenda }}
            >
                {children}
            </a>
        ) : (
            <>{children}</>
        )
    )
}